import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import * as sharedENTranslations from "../packages/shared/i18n/en/translations.json";
import * as sharedPLTranslations from "../packages/shared/i18n/pl/translations.json";
import * as sharedUKTranslations from "../packages/shared/i18n/uk/translations.json";
import * as visitsENTranslations from "./locales/en/translations.json";
import * as visitsPLTranslations from "./locales/pl/translations.json";
import * as visitsUKTranslations from "./locales/uk/translations.json";

type TranslationKey = "pl" | "en" | "uk";
type TranslationRecord = Record<string, string>;
type GonData = {
  cmsTranslations?: Record<TranslationKey, TranslationRecord>;
  locale?: TranslationKey;
};

declare global {
  interface Window {
    gon?: GonData;
  }
}

const gonData = window.gon;
const cmsPLTranslations = gonData?.cmsTranslations?.pl ?? {};
const cmsENTranslations = gonData?.cmsTranslations?.en ?? {};
const cmsUKTranslations = gonData?.cmsTranslations?.uk ?? {};

i18n.use(initReactI18next).init({
  resources: {
    pl: {
      shared: sharedPLTranslations,
      translation: { ...sharedPLTranslations, ...visitsPLTranslations, cmsTranslations: cmsPLTranslations },
    },
    en: {
      translation: { ...visitsENTranslations, ...sharedENTranslations, cmsTranslations: cmsENTranslations },
    },
    uk: {
      translation: { ...visitsUKTranslations, ...sharedUKTranslations, cmsTranslations: cmsUKTranslations },
    },
  },
  ns: ["shared", "translation"],
  defaultNS: "translation",
  lng: gonData?.locale ?? "pl",
  fallbackLng: ["pl", "en", "uk"],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
